import React, { Component } from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import connect from '../store/connect';
import { setViewstate, removeViewstate, fetchProducts, fetchCategoryMetaData } from '../actions/actionCreators';
import { getProductsByKey } from '../selectors/reselectCategory';
import Page from './Page';
import { Heading } from '../styles/Heading';
import { Container } from '../styles/Container';
import ProductListWithFilters from '../components/ProductListWithFilters';
import TruncatedPreamble from '../components/TruncatedPreamble';
import ErrorPage from './ErrorPage';
import NotFoundPage from './NotFoundPage';
import { NoProductsFound } from '../styles/NoProductsFound';

class BrandPage extends Component {
  componentDidMount() {
    this.props.fetchCategoryMetaData({
      url: this.props.match.url
    });

    if (
      !this.props.viewstate.has('currentCategory') ||
      this.props.viewstate.get('currentCategory') !== this.props.currentPage.get('id')
    ) {
      this.props.setViewstate('currentCategory', this.props.currentPage.get('id'));
      this.props.setViewstate('sortAscending', false);
      this.props.setViewstate('sortBy', 'name');
      this.props.removeViewstate('filter');
      this.props.setViewstate('pagination', 0);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentPage.get('systemId') && !this.props.currentPage.get('systemId')) {
      this.props.fetchProducts({
        id: nextProps.currentPage.get('systemId'),
        url: nextProps.match.url
      });
    }
  }

  componentDidUpdate() {
    if (
      !this.props.viewstate.has('currentCategory') ||
      this.props.viewstate.get('currentCategory') !== this.props.currentPage.get('id')
    ) {
      this.props.setViewstate('currentCategory', this.props.currentPage.get('id'));
      this.props.setViewstate('sortAscending', false);
      this.props.setViewstate('sortBy', 'name');
      this.props.removeViewstate('filter');
      this.props.setViewstate('pagination', 0);
    }
  }

  render() {
    const { request, productsRequest } = this.props;

    if (request.get('statusCode') === 404) return <NotFoundPage />;
    if (request.get('status') === 'ERROR') return <ErrorPage />;

    return (
      <Page
        meta={this.props.currentPage.get('metaData')}
        bgColor="#f2f2f2"
        lastBreadcrumbItem={{ title: this.props.currentPage.get('name'), url: this.props.location.pathname }}
      >
        <Container>
          <Heading big center>
            {this.props.currentPage.get('name')}
          </Heading>
          <TruncatedPreamble>{this.props.currentPage.get('description')}</TruncatedPreamble>
        </Container>
        {productsRequest.get('statusCode') === 200 && this.props.products.size <= 0 ? (
          <Container>
            <NoProductsFound>
              Vi jobbar med att berika vår webbplats med produkter från {this.props.currentPage.get('name')}. Nya
              produkter kommer inom kort.
            </NoProductsFound>
          </Container>
        ) : (
          <ProductListWithFilters includeCategoryFilter request={productsRequest} allProducts={this.props.products} />
        )}
      </Page>
    );
  }
}

BrandPage.defaultProps = {
  products: Map(),
  currentPage: Map(),
  request: Map(),
  productsRequest: Map(),
  viewstate: Map()
};

BrandPage.propTypes = {
  location: PropTypes.object.isRequired,
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  fetchCategoryMetaData: PropTypes.func.isRequired,
  products: PropTypes.instanceOf(Map),
  currentPage: PropTypes.instanceOf(Map),
  request: PropTypes.instanceOf(Map),
  productsRequest: PropTypes.instanceOf(Map),
  match: PropTypes.object.isRequired,
  viewstate: PropTypes.instanceOf(Map)
};

// get data product list data from endpoint
export default connect(
  BrandPage,
  { setViewstate, removeViewstate, fetchProducts, fetchCategoryMetaData },
  (store, props) => {
    const pathname = props.location.pathname.replace(/\/$/, '');
    const currentPage = store.categories.items.get(pathname);
    const products = !currentPage
      ? Map()
      : getProductsByKey(store, [props.type, 'systemId'], currentPage.get('systemId'));

    return {
      products,
      viewstate: store.viewstate,
      currentPage,
      request: store.categories.request.get(pathname),
      productsRequest: store.products.request.get(pathname)
    };
  }
);



// WEBPACK FOOTER //
// ./src/pages/BrandPage.js